<template>
   <div class="gens-universes">
       <div class="gens-detail">
           <div class="detail-content">
               <div class="post_image">
                    <img class="post_image_img" src="../../assets/images/gensunicerse/181002-feature-breast-cancer.jpg"/>
               </div>
               <div class="post_text">
                   <div class="post_tip">邵逸夫奖得奖科学家预计 中国女性患乳腺癌的风险将持续上升</div>
                   <div class="post_info">Posted at 09:00h in 癌症</div>
                    <div class="post_tip_1" style="margin-top:0px !important;">
                        乳癌是本港女性最常见的癌症。 2015年，共有3900名女性患上乳腺癌，占本港女性癌症新症总数的26.1 %，即逾四分一。 2016年，本港因乳腺癌而离世的女性超过700人，占女性因患癌症而死亡的总数12.2%。<br /><br />

                        虽然非癌症的头号杀手，但一位科学家就预计在中国及香港，患上乳腺癌的女性只会有增无减，这位科学家就是今届邵逸夫奖生命科学与医学奖的得奖者玛莉-克莱尔• 金(Mary-Claire King)。<br /><br />

                        她早于1974年开始研究乳腺癌与基因的关系，发现部分乳腺癌由遗传所引起，她的研究结果改变了整个研究领域，亦引发国际间持续研究，致使今天我们可以透过检测各种基因突变，及早预防患上乳癌的机会。
                    </div>
                    <div class="post_wrapper_1">
                        今年72岁的金教授在美国芝加哥出生，现为华盛顿大学医学系和基因组科学系美国癌症协会讲座教授。她自1974年开始对乳癌进行研究，当时社会上普遍认为癌症由病毒所引起，因此金教授提出乳癌或与基因有关时，遇到不少质疑，然而她仍坚持研究。
                    </div>
                    <div class="text_img_flex">
                        <div class="text_img_img">
                             <img  src="../../assets/images/gensunicerse/181002-Mary-Claire-King.jpg"/>
                             <div class="bottom_tip">乳癌是本港女性最常见的癌症。一位科学家就预计在中国及香港，患上乳腺癌的女性只会有增无减。</div>
                        </div>
                        <div class="text_img_text">
                            <div class="post_wrapper_tip">力排众议研究　终找出乳腺癌基因──17号染色​​体</div>
                             <div class="post_wrapper_1">
                                她最终透过统计学及利用数学模型，找出乳腺癌基因的所在，亦即人类的17号染色​​体，她将其命名为BRCA1。当时并无人类基因图谱，金教授的发现实属划时代。
                            </div>
                            <div class="post_wrapper_1">
                                期后，不少科学家对此继续进行研究，再发现BRCA2及其他类型的基因突变，现时已知的共有20多种。
                            </div>
                            <div class="post_wrapper_tip margin_top">检测基因突变 可及早预防患上乳腺癌</div>
                             <div class="post_wrapper_1">
                                金教授指，女士可透过检测基因突变预防患上乳腺癌，现时国际间建议，若女性检测到自己带有BRCA1或BRCA2的基因，若已年过40岁及不需生育，便应切除卵巢及输卵管，以降低身体内的雌激素，有助减低患上乳腺癌的机会。
                            </div>
                            <div class="text_img_text_img">
                                <img  src="../../assets/images/gensunicerse/181002-gene-mutation.jpg"/>
                                <div class="bottom_tip">乳癌是本港女性最常见的癌症。一位科学家就预计在中国及香港，患上乳腺癌的女性只会有增无减。</div>
                             </div>
                        </div>
                    </div>
                    <div style="text-align:left;">
                    <div class="post_wrapper_tip">女性患乳癌机会随年龄上升而增加</div>
                    <div class="post_wrapper_1">
                     金教授指，在美国，女性患上乳癌的风险会随年龄上升而增长，带有BRCA1基因变异的女性，在40岁时的风险是约25%；在60岁时上升至60%；及至80岁可高达83%。她指，虽然针对中国人的研究仍在进行之中，但她相信有关数据在中国或会相同，甚至预言情况可能只会愈来愈严重。
                     </div>
                     <div class="post_wrapper_tip">青春期推前 生育年龄推后 致乳癌患者增多</div>
                    <div class="post_wrapper_1">
                     她解释，女性在青春期出现后，雌激素便会增加，及至生育后才可取得平衡。但由于现今社会，女性可吸收的营养愈来愈多，青春期会提早出现；但同时教育水平亦不断上升，令女性生育的年龄延后，「在100年前，青春期及生小孩两者之间，可能只相距数年，但现在至少超过20年，令女性患上乳腺癌的风险变得更大，在中国很明显有这变化，相信会有更多人患上乳腺癌。」
                     </div>
                    <div class="post_wrapper_1">
                    她形容乳癌有一种罕见情况：「即使生活条件得到改善，患上乳腺癌的人数只会继续上升。」
                     </div>
                     
                     <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/181002-cancer-fund.jpg"/>
                        <div class="bottom_tip">
                            乳癌是本港女性最常见的癌症。一位科学家就预计在中国及香港，患上乳腺癌的女性只会有增无减。
                        </div>
                    </div>  
                      <div class="post_wrapper_1">
                        參考資料：<a href="https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/241457/%E9%82%B5%E9%80%B8%E5%A4%AB%E7%8D%8E%E5%BE%97%E7%8D%8E%E7%A7%91%E5%AD%B8%E5%AE%B6%E9%A0%90%E8%A8%88-%E4%B8%AD%E5%9C%8B%E5%A5%B3%E6%80%A7%E6%82%A3%E4%B9%B3%E8%85%BA%E7%99%8C%E7%9A%84%E9%A2%A8%E9%9A%AA%E5%B0%87%E6%8C%81%E7%BA%8C%E4%B8%8A%E5%8D%87">
                        香港01</a>
                    </div>
                    </div>
               </div>
           </div>
          <div class="detail-list-menu">
               <div class="list-menu-item">
                   	<h5>最新資訊</h5>		
                       <ul>
							<li>
					            <a href="#/gensone">無免疫力孕婦的患麻疹 最嚴重可流產</a>
							</li>
							<li>
					            <a href="#/genstwo">無入侵性抽血驗癌症 適宜年老病人</a>
							</li>
							<li>
					            <a href="#/gensthree">最易被忽略的一種過敏食物</a>
							</li>
							<li>
					            <a href="#/gensfour">樂觀女性生仔機會較大</a>
						    </li>
							<li>
					            <a href="#/gensfive">雙胞胎兒竟然是同母異父</a>
							</li>
					</ul>
               </div>
               <div class="list-menu-item">
                   <h5>分類</h5>		
                   <ul>
				       <li>
                           <a href="#/gensuniversecate?categoryName=传染病&isCategory=1">傳染病</a> (2)
                       </li>
                       <li >
                           <a href="#/gensuniversecate?categoryName=天赋基因&isCategory=1">天賦基因</a> (1)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=无创产前检测&isCategory=1">無創產前檢測</a> (2)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=生育健康&isCategory=1">生育健康</a> (4)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=癌症&isCategory=1">癌症</a> (4)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=致敏原&isCategory=1">致敏原</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=亲子鉴定&isCategory=1">親子鑑定</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=遗传病&isCategory=1">遺傳病</a> (1)
                        </li>
                    </ul>
               </div>
           </div>
       </div>
   </div>
</template>
<script>
export default {
    data(){
        return{
          
        }
    },
    mounted(){

    },
    methods:{

    }
}
</script>


<style lang="scss" scoped>
.gens-universes{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    margin-bottom:25px;
    
    font-family: 'Microsoft JhengHei',sans-serif !important;
      margin-top:25px;
    .gens-detail{
        text-align: left;
        margin-top:10px;
        width:57.5%;
        margin:auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .detail-content{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width:66.66%;
            .post_image{
                position: relative;
                width: 100%;
                display: block;
                .post_image_img{
                   max-width: 100%;
                   height: auto; 
                }
            }
            .post_text{
                display: contents;
                .post_tip{
                    margin-top:35px;
                    color: #368da7;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 600;
                    letter-spacing: 0;
                    text-transform: none;
                }
                .post_info{
                    display: inline-block;
                    width: 100%;
                    margin: 0 0 18px;
                    color: #bebebe;
                    font-weight: 500;
                    line-height: 27px;
                    font-size: 16px;
    
                }
                .post_wrapper{
                    
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                }
                .post_tip_1{
                    margin-top:35px;
                    border-color: #368da7;
                    background-color: #e9faff;
                    padding: 14px 14px 14px 10px;
                    border-left: 4px solid #368da7;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;

                }
                .post_wrapper_1{
                    margin-top:15px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
                .post_wrapper_1 a{
                    color:#368da7;
                    text-decoration: none;
                }
                .post_wrapper_1 a:hover{
                    color:#9bd9dd;;
                    text-decoration: none;
                }
                .post_wrapper_tip{
                    margin-top:35px;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    text-transform: none;
                    color: #368da7;
                }
                .post_wrapper_img{
                    margin-top:35px;
                    text-align: center;
                    img{
                        vertical-align: middle;
                        height: auto;
                        max-width: 100%;
                    }
                    .bottom_tip{
                        margin-top: .2em;
                       font-size: .8em;
                    }
                }
                .text_img_flex{
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    flex-direction: row;
                    vertical-align: top;
                    margin: 0;
                    max-width: 100%;
                    margin-top:25px;
                   .text_img_img{
                       display: block;
                       width: 240px;
                       height: auto;
                        max-width: 100%;
                        vertical-align: top;
                        img{
                            width:240px;
                        }
                        .bottom_tip{
                            text-align: center;
                        }
                        
                   }
                   .text_img_text{
                       margin-left:25px;
                        margin-right:15px;
                         .post_wrapper_tip{
                            margin-top:0px !important;
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 600;
                            text-transform: none;
                            color: #368da7;
                        }
                        .margin_top{
                            margin-top:20px !important;
                        }
                        .text_img_text_img{
                            margin-top:26px;
                            display: block;
                            width: 460px;
                            height: auto;
                            vertical-align: top;
                            img{
                                width:460px;
                            }
                            .bottom_tip{
                                text-align: center;
                            }
                        }
                   }
                }
                .margin_top{
                    margin-top:35px;
                }
            }
            
        }
        .detail-list-menu{
            width: 33.33%;
            display: flex;
            padding-left:40px;
            justify-content: left;
            align-items: flex-start;
            flex-direction: column; 
            align-self: flex-start;
            .list-menu-item{

                width:100%;
                background-color: #f3f3f3!important;
                padding: 14px!important;
                box-shadow: 4px 4px 5px #cfcfcf;
                margin: 0 0 42px;
            }
            .list-menu-item h5{
                 color: #368da7!important;
                 font-size: 18px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
            }
            .list-menu-item ul{
                list-style: none;
                padding: 0;
                background: 0 0;
                border: 0;
                margin: 0;
                padding: 0;
                vertical-align: baseline;
                outline: 0;
                color: #3b3b3b;
            }
            .list-menu-item li{
                line-height: 27px;
                letter-spacing: .07em!important;
                font-size: 14px;
                padding: 5px 0;
                margin: 0;
                vertical-align: baseline;
            }
            .list-menu-item a{
                
                text-decoration: none;
                color:  #303030 !important;
                font-weight: 400;
            }
            .list-menu-item a:hover{
                color: #9bd9dd !important;
                font-weight: 400;
            }
        }
    }

    
           
}
</style>


// WEBPACK FOOTER //
// src/view/gensuniversedetail/gensten.vue